import React, { useState, useEffect } from "react";

function Bannerz() {
  

  const images = [

    {
      url: "https://tripjive.com/wp-content/uploads/2024/02/Bahamas-Itinerary-10-Days.jpg",

    },

    {
      url: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/16/17/5d/96/caption.jpg?w=1200&h=-1&s=1",
    },

    {
      url: " https://www.worldofcruising.co.uk/uploads/images/_size1900/82008474/Caribbean_1_xyby787.webp",
    },


    {
      url: "https://d1u39ah4l74ffy.cloudfront.net/img/NzIlPiQsMmhwa2Jnfg/1024/1/harbour-house-towers-804-grand-bahama-freeport-bs.webp?t=294287",
    },

   
    {
      url: "https://discovermybahamas.com/wp-content/uploads/2023/08/FREEPORT-DOWNTOWN-1.jpg",
    },

    {
      url: "https://firebasestorage.googleapis.com/v0/b/cnccarrental-b496d.appspot.com/o/bibis.jpg?alt=media&token=99d65890-476b-45ba-8de9-f7cfe3db735c",
    },
    
  
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  };

  return (
    <>
      <section
        className="banner-section"
        style={{
          // backgroundColor: '#00b712',
          // backgroundImage: 'linear-gradient(95deg, #00690a 0%, #3a9e0e 79%)'
          position: 'relative',  zIndex: '28',
          height: '600px', // Default height for larger screens
          ...(window.innerWidth < 600 && { height: '300px' }), // Dynamic height for mobile view
        }}
      >
         <img alt="Background Shape" style={bgImageStyle}  src={images[currentIndex].url}
            />
      

  
    </section>
  </>
);
}

export default Bannerz;